import type { ReactNode } from "react";
import { connect } from "react-redux";
import type { Dispatch } from "redux";

import actions from "@/actions";

import Button from "../base/Button";

const renderIcon = (color: string): ReactNode => (
    <svg width="33px" height="34px" viewBox="0 0 33 34" version="1.1">
        <title>delete</title>
        <desc>Created with Sketch.</desc>
        <defs />
        <g
            id="Symbols---Zep"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="square"
        >
            <g
                id="LS-Menu"
                transform="translate(-202.000000, -13.000000)"
                stroke={color}
            >
                <g id="delete">
                    <g transform="translate(202.500000, 14.000000)">
                        <polyline
                            id="Shape"
                            points="28.6315789 5.05263158 28.6315789 32 5.05263158 32 5.05263158 5.05263158"
                        />
                        <path d="M0,5.05263158 L32,5.05263158" id="Shape" />
                        <path d="M16,13.4736842 L16,21.8947368" id="Shape" />
                        <path
                            d="M10.1052632,13.4736842 L10.1052632,21.8947368"
                            id="Shape"
                        />
                        <path
                            d="M21.8947368,13.4736842 L21.8947368,21.8947368"
                            id="Shape"
                        />
                        <polyline
                            id="Shape"
                            points="11.1052632 5.05263158 11.1052632 0 22.8947368 0 22.8947368 5.05263158"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

const DeleteButton = (props: React.ComponentProps<typeof Button>) => (
    <Button {...props} renderIcon={renderIcon} />
);

const mapStateToProps = ({ map }: { map: any }) => ({
    disabled:
        map.general.selectedLights.length <= 0 &&
        map.general.selectedMarkers.length <= 0,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    onClick: () => {
        dispatch(actions.map.general.deleteLights());
        dispatch(actions.map.general.deleteMarkers());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteButton);
